
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { bool_type, record_type, class_type, option_type, list_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { StocktakingListDto_$reflection, StocktakingDetailDto_$reflection, StocktakingResultType_$reflection } from "../../Shared/Stocktaking.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, RequestedValue$1_$reflection, StocktakingListId_$reflection, StocktakingId_$reflection } from "../../Shared/Shared.js";
import { ChangelogDto_$reflection } from "../../Shared/Changelog.js";

export class SelectedTab extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["OpenTasks", "AllRows", "Changelog"];
    }
}

export function SelectedTab_$reflection() {
    return union_type("Stocktaking.StocktakingList.Types.SelectedTab", [], SelectedTab, () => [[], [], []]);
}

export class StocktakingListTableRow extends Record {
    constructor(ImageUrl, InventoryNumber, Unit, Name, Manufacturer, Model, SerialNumber, QRCodeIds, StorageSpace, Quantity, RecordedBy, RecordTimestamp, RecordedQuantity, CorrectedBy, CorrectionTimestamp, CorrectionQuantity, StocktakingResultType) {
        super();
        this.ImageUrl = ImageUrl;
        this.InventoryNumber = InventoryNumber;
        this.Unit = Unit;
        this.Name = Name;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.SerialNumber = SerialNumber;
        this.QRCodeIds = QRCodeIds;
        this.StorageSpace = StorageSpace;
        this.Quantity = Quantity;
        this.RecordedBy = RecordedBy;
        this.RecordTimestamp = RecordTimestamp;
        this.RecordedQuantity = RecordedQuantity;
        this.CorrectedBy = CorrectedBy;
        this.CorrectionTimestamp = CorrectionTimestamp;
        this.CorrectionQuantity = CorrectionQuantity;
        this.StocktakingResultType = StocktakingResultType;
    }
}

export function StocktakingListTableRow_$reflection() {
    return record_type("Stocktaking.StocktakingList.Types.StocktakingListTableRow", [], StocktakingListTableRow, () => [["ImageUrl", string_type], ["InventoryNumber", string_type], ["Unit", string_type], ["Name", string_type], ["Manufacturer", string_type], ["Model", string_type], ["SerialNumber", string_type], ["QRCodeIds", list_type(string_type)], ["StorageSpace", string_type], ["Quantity", string_type], ["RecordedBy", option_type(string_type)], ["RecordTimestamp", option_type(class_type("System.DateTime"))], ["RecordedQuantity", option_type(string_type)], ["CorrectedBy", option_type(string_type)], ["CorrectionTimestamp", option_type(class_type("System.DateTime"))], ["CorrectionQuantity", option_type(string_type)], ["StocktakingResultType", StocktakingResultType_$reflection()]]);
}

export class DialogOpenState extends Record {
    constructor(IsConfirmationStateStartDialogOpen, IsConfirmationStateDoneDialogOpen) {
        super();
        this.IsConfirmationStateStartDialogOpen = IsConfirmationStateStartDialogOpen;
        this.IsConfirmationStateDoneDialogOpen = IsConfirmationStateDoneDialogOpen;
    }
}

export function DialogOpenState_$reflection() {
    return record_type("Stocktaking.StocktakingList.Types.DialogOpenState", [], DialogOpenState, () => [["IsConfirmationStateStartDialogOpen", bool_type], ["IsConfirmationStateDoneDialogOpen", bool_type]]);
}

export class State extends Record {
    constructor(StocktakingId, StocktakingListId, Stocktaking, StocktakingList, Changelogs, DialogOpenState, FormState) {
        super();
        this.StocktakingId = StocktakingId;
        this.StocktakingListId = StocktakingListId;
        this.Stocktaking = Stocktaking;
        this.StocktakingList = StocktakingList;
        this.Changelogs = Changelogs;
        this.DialogOpenState = DialogOpenState;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Stocktaking.StocktakingList.Types.State", [], State, () => [["StocktakingId", StocktakingId_$reflection()], ["StocktakingListId", StocktakingListId_$reflection()], ["Stocktaking", RequestedValue$1_$reflection(StocktakingDetailDto_$reflection())], ["StocktakingList", RequestedValue$1_$reflection(StocktakingListDto_$reflection())], ["Changelogs", RequestedValue$1_$reflection(list_type(ChangelogDto_$reflection()))], ["DialogOpenState", DialogOpenState_$reflection()], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FetchStocktaking", "FetchChangelogs", "StocktakingFetched", "SetStocktakingStateStart", "SetStocktakingStateDone", "OnCloseConfirmationStateStartDialog", "OnCloseConfirmationStateDoneDialog", "StocktakingStateSet", "ChangelogsFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Stocktaking.StocktakingList.Types.Msg", [], Msg, () => [[], [], [["Item", StocktakingDetailDto_$reflection()]], [], [], [["Item", bool_type]], [["Item", bool_type]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", list_type(ChangelogDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

